export const successMessage = "Transaction was Successful.";
export const progressMessage = "Transaction in progress, please stand by...";